import { SetupImageCarousel } from '@components'
import type { Setup } from '@here/api'
import { type ParentComponent, Show, createSignal } from 'solid-js'
import { Flex, Grid } from 'styled-system/jsx'
import { Image } from './Image'

interface HeaderProps {
	setup: Setup
}

const Images: ParentComponent<HeaderProps> = (props) => {
	const [openImage, setOpenImage] = createSignal<number>()

	const images = [
		{
			title: 'Pattern',
			src: props.setup?.image_pattern ?? undefined,
		},
		{
			title: 'Macro',
			src: props.setup?.image_macro ?? undefined,
		},
		{
			title: 'Trend',
			src: props.setup?.image_trend ?? undefined,
		},
		{
			title: 'Trigger',
			src: props.setup?.image_trigger ?? undefined,
		},
		{
			title: 'Time Stop',
			src: props.setup?.image_time_stop ?? undefined,
		},
		{
			title: 'Volume by price',
			src: props.setup?.image_volume_by_price ?? undefined,
		},
	].filter((image) => image.src)

	return (
		<>
			<SetupImageCarousel
				images={images}
				openImage={openImage}
				setIsOpen={setOpenImage}
			/>
			<Grid
				gridTemplateColumns={{
					base: '1fr 350px',
					lgDown: '1fr 1fr',
					smDown: '1fr',
				}}
				gap={4}
			>
				<Image
					image={images[0]}
					onClick={() => setOpenImage(() => 0)}
				/>

				<Grid>
					<Image
						image={images[1]}
						onClick={() => setOpenImage(() => 1)}
					/>

					<Image
						image={images[2]}
						onClick={() => setOpenImage(() => 2)}
					/>

					<Image
						image={images[3]}
						onClick={() => setOpenImage(() => 3)}
					/>

					<Show when={images[4] || images[5]}>
						<Flex gap={2}>
							<Show when={images[4]}>
								<Image
									image={images[4]}
									onClick={() => setOpenImage(() => 4)}
								/>
							</Show>
							<Show when={images[5]}>
								<Image
									image={images[5]}
									onClick={() => setOpenImage(() => 5)}
								/>
							</Show>
						</Flex>
					</Show>
				</Grid>

			</Grid>
		</>
	)
}

export default Images
